module.exports = __webpack_public_path__ + "img/icon_img31.d72c7c4b.png";